// ----------------- Configuration Variables ---------------------
// Configure tracking IDs and labels here
const CONFIG = {

  googleAds: {
    id: "AW-11389345747", 
    conversionLabel: "2BqvCOuU3K8aENO_7rYq", 
    pageViewLabel: null,
    purchaseLabel: null, 
    paymentInfoLabel: null, 
    checkoutLabel: null
  },
  
  // Google Analytics ID
  analytics: "G-KJHM691CQD",
  
  // Google Merchant Center ID 
  merchantCenter: null,
  
  // General settings
  language: "en-gb",
  orderCompleteTitle: "Breeze Checkout Thank You Page"
};

// ----------------- Initialization ----------------------------------
window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}
gtag("js", new Date());

// Add Google Tag Manager script
(function() {
  if (CONFIG.analytics) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${CONFIG.analytics}`;
    document.head.appendChild(script);
  }
})();

// Configure all tracking IDs
function configureTracking() {
  // Configure Google Ads account
  if (CONFIG.googleAds && CONFIG.googleAds.id) {
    gtag("config", CONFIG.googleAds.id);
  }
  
  // Configure Analytics account
  if (CONFIG.analytics) {
    gtag("config", CONFIG.analytics);
  }
}

// ----------------- Helper Functions ----------------------------------

function getScreenResolution() {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  return screenHeight + "x" + screenWidth;
}

function getGAClientIDfromMeasurementID() {
  try {
    var match = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)"),
      raw = match ? decodeURIComponent(match[1]) : null;
    if (raw) {
      match = raw.match(/(\d+\.\d+)$/);
    }
    return match ? match[1] : null;
  } catch (e) {
    return null;
  }
}

function getMerchantDomain() {
  try {
    const currentDomain = window.location.hostname;
    const domainParts = currentDomain.split(".");
    const tld = domainParts.slice(-2).join(".");
    return tld;
  } catch {
    return null;
  }
}

function getCurrentPageUrl() {
  return window.location.href;
}

function getConvertedItems(items) {
  return items.map((item) => ({
    id: item.id,
    name: item.name,
    price: item.price,
    quantity: item.quantity,
    variant: item.variant
  }));
}

// Get list of send_to destinations for page_view events
function getSendToDestinations() {
  const destinations = [];
  
  // Add analytics ID
  if (CONFIG.analytics) {
    destinations.push(CONFIG.analytics);
  }
  
  // Add Google Ads ID with page view label
  if (CONFIG.googleAds && CONFIG.googleAds.id) {
    if (CONFIG.googleAds.pageViewLabel) {
      destinations.push(`${CONFIG.googleAds.id}/${CONFIG.googleAds.pageViewLabel}`);
    } else {
      destinations.push(CONFIG.googleAds.id);
    }
  }
  
  // Add Merchant Center if configured
  if (CONFIG.merchantCenter) {
    destinations.push(CONFIG.merchantCenter);
  }
  
  return destinations;
}

// Get conversion destinations for specific event type
function getEventDestination(eventType) {
  const destinations = [];
  
  if (CONFIG.googleAds && CONFIG.googleAds.id) {
    let label = null;
    
    switch(eventType) {
      case 'conversion':
        label = CONFIG.googleAds.conversionLabel;
        break;
      case 'purchase':
        label = CONFIG.googleAds.purchaseLabel;
        break;
      case 'payment_info':
        label = CONFIG.googleAds.paymentInfoLabel;
        break;
      case 'checkout':
        label = CONFIG.googleAds.checkoutLabel;
        break;
    }
    
    // Only add destination if label exists and is not null
    if (label) {
      destinations.push(`${CONFIG.googleAds.id}/${label}`);
    }
  }
  
  // Add Merchant Center for purchase events if configured
  if (eventType === 'purchase' && CONFIG.merchantCenter) {
    destinations.push(CONFIG.merchantCenter);
  }
  
  return destinations;
}

// ----------------- Event Listeners ----------------------------------

// Purchase event listener
window.addEventListener("breeze-purchase", (event) => {
  try {
    const params = event.detail.data;
    
    // Configure tracking IDs
    configureTracking();

    // Send conversion event if label exists
    if (CONFIG.googleAds && CONFIG.googleAds.id && CONFIG.googleAds.conversionLabel) {
      gtag("event", "conversion", {
        send_to: `${CONFIG.googleAds.id}/${CONFIG.googleAds.conversionLabel}`,
        value: params.totalPrice,
        currency: params.currency,
        transaction_id: params.shopOrderId,
        breeze_event_type: "breeze_conversion",
        breeze_event_send_to: ["AW"],
        breeze_event_time: new Date().toISOString()
      });
    }

    // Send remarketing page_view event
    if (CONFIG.googleAds && CONFIG.googleAds.id) {
      gtag("event", "page_view", {
        send_to: CONFIG.googleAds.id,
        ecomm_pagetype: "purchase",
        ecomm_totalvalue: params.totalPrice,
        breeze_event_type: "breeze_page_view",
        breeze_event_send_to: ["AW"],
        breeze_event_time: new Date().toISOString()
      });
    }

    // Combined page_view event
    const pageViewDestinations = getSendToDestinations();
    if (pageViewDestinations.length > 0) {
      gtag("event", "page_view", {
        send_to: pageViewDestinations,
        page_title: CONFIG.orderCompleteTitle,
        page_location: getCurrentPageUrl(),
        ignore_referrer: "true",
        breeze_event_type: "breeze_page_view",
        breeze_event_send_to: ["G", "AW", "MC"],
        breeze_event_time: new Date().toISOString()
      });
    }

    // Purchase event - only send if we have destinations
    const purchaseDestinations = getEventDestination('purchase');
    if (purchaseDestinations.length > 0) {
      gtag("event", "purchase", {
        send_to: purchaseDestinations,
        value: params.totalPrice,
        currency: params.currency,
        transaction_id: params.shopOrderId,
        shipping: params.shippingCharge,
        items: getConvertedItems(params.items),
        ignore_referrer: "true",
        breeze_event_type: "breeze_purchase",
        breeze_event_send_to: ["AW", "MC"],
        breeze_event_time: new Date().toISOString()
      });
    }

    // Completed order event for analytics
    if (CONFIG.analytics) {
      gtag("event", "Completed Order", {
        currency: params.currency,
        language: CONFIG.language,
        page_title: CONFIG.orderCompleteTitle,
        screen_resolution: getScreenResolution(),
        client_id: getGAClientIDfromMeasurementID(),
        event_category: "EnhancedEcommerce",
        allow_display_features: true,
        allow_ad_personalization_signals: true,
        cookie_domain: getMerchantDomain(),
        cookie_flags: "",
        cookie_path: "/",
        send_to: CONFIG.analytics,
        breeze_event_type: "breeze_complete_order",
        breeze_event_send_to: ["G"],
        breeze_event_time: new Date().toISOString()
      });

      // GA4 page view event
      gtag("event", "page_view", {
        event_category: "All",
        value: params.totalPrice,
        send_to: CONFIG.analytics,
        breeze_event_type: "breeze_page_view",
        breeze_event_send_to: ["G"],
        breeze_event_time: new Date().toISOString()
      });
    }
  } catch (e) {
    console.error("Purchase tracking error:", e);
  }
});

// Add Payment Info event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  try {
    const params = event.detail.data;
    
    // Configure tracking IDs
    configureTracking();

    // Page view event
    const pageViewDestinations = getSendToDestinations();
    if (pageViewDestinations.length > 0) {
      gtag("event", "page_view", {
        send_to: pageViewDestinations,
        page_title: CONFIG.orderCompleteTitle,
        page_location: getCurrentPageUrl(),
        ignore_referrer: "true",
        breeze_event_type: "breeze_page_view",
        breeze_event_send_to: ["G", "AW", "MC"],
        breeze_event_time: new Date().toISOString()
      });
    }

    // Add payment info event - only send if we have destinations
    const paymentInfoDestinations = getEventDestination('payment_info');
    if (paymentInfoDestinations.length > 0) {
      gtag("event", "add_payment_info", {
        send_to: paymentInfoDestinations,
        currency: params.currency,
        value: params.totalPrice,
        total: params.itemCount,
        ignore_referrer: "true",
        breeze_event_type: "breeze_add_payment_info",
        breeze_event_send_to: ["AW"],
        breeze_event_time: new Date().toISOString()
      });
    }
  } catch (e) {
    console.error("Add payment info tracking error:", e);
  }
});

// Begin Checkout event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  try {
    const params = event.detail.data;
    
    // Configure tracking IDs
    configureTracking();

    // Page view event
    const pageViewDestinations = getSendToDestinations();
    if (pageViewDestinations.length > 0) {
      gtag("event", "page_view", {
        send_to: pageViewDestinations,
        page_title: CONFIG.orderCompleteTitle,
        page_location: getCurrentPageUrl(),
        ignore_referrer: "true",
        breeze_event_type: "breeze_page_view",
        breeze_event_send_to: ["G", "AW", "MC"],
        breeze_event_time: new Date().toISOString()
      });
    }

    // Begin checkout event - only send if we have destinations
    const checkoutDestinations = getEventDestination('checkout');
    if (checkoutDestinations.length > 0) {
      gtag("event", "begin_checkout", {
        send_to: checkoutDestinations,
        ecomm_totalvalue: params.totalPrice,
        value: params.totalPrice,
        currency: params.currency,
        items: getConvertedItems(params.items),
        ignore_referrer: "true",
        breeze_event_type: "breeze_checkout_initiated",
        breeze_event_send_to: ["AW"],
        breeze_event_time: new Date().toISOString()
      });
    }
  } catch (e) {
    console.error("Begin checkout tracking error:", e);
  }
});